import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Badge,
  BadgeStatusEntrega,
  CustomModal,
  InputText,
  NumeroDecimal,
  ThreeDots,
} from '../../../../components'
import * as colors from '../../../../assets/js/colors'
import { tableCellCentered } from '../../../../assets/js/styles'

const STATUSES_REQUEREM_CANHOTO = [8, 10]

function ModalDetalhesVeiculo({ visible, veiculo, entregas, onClose, history, pInicial, pFinal }) {
  const [filtroTexto, setFiltroTexto] = useState('')

  if (!veiculo) return null

  // Filtrar entregas baseado no texto de busca
  const entregasFiltradas =
    entregas.filter(entrega => {
      if (!filtroTexto) return true

      const textoLower = filtroTexto.toLowerCase()
      return (
        entrega.identifier.toLowerCase().includes(textoLower) ||
        entrega.nomeFantasia.toLowerCase().includes(textoLower) ||
        entrega.city.toLowerCase().includes(textoLower) ||
        entrega.district.toLowerCase().includes(textoLower) ||
        entrega.company_name.toLowerCase().includes(textoLower) ||
        entrega.status.toLowerCase().includes(textoLower)
      )
    }) || []

  const handleClose = () => {
    setFiltroTexto('')
    onClose()
  }

  return (
    <CustomModal
      header={`Detalhes da Rota - ${veiculo.fleet_id}`}
      isVisible={visible}
      onClose={handleClose}
      maximizable={false}
      width="95vw"
      contentStyle={{ height: '85vh', overflow: 'auto' }}
    >
      <div className="painel-veiculos__modal-header">
        <div className="painel-veiculos__modal-info">
          <strong>Rota:</strong> {veiculo.fleet_id}
        </div>
        <div className="painel-veiculos__modal-info">
          <strong>Placa:</strong> {veiculo.vehicle_badge}
        </div>
        <div className="painel-veiculos__modal-info">
          <strong>Motorista:</strong> {veiculo.driver_name}
        </div>
        <div className="painel-veiculos__modal-info">
          <strong>Data de Envio:</strong> {veiculo.sent_time}
        </div>
      </div>

      <div className="p-grid" style={{ marginTop: 20, marginBottom: 10 }}>
        <div className="p-col-12 p-md-6 p-lg-4">
          <InputText
            label="Filtrar:"
            value={filtroTexto}
            onChange={value => setFiltroTexto(value)}
            placeholder="Buscar por identificador, fantasia, cidade, bairro, empresa ou status..."
          />
        </div>
      </div>

      <DataTable
        value={entregasFiltradas}
        rows={15}
        emptyMessage="Nenhuma entrega encontrada"
        style={{ marginTop: 10 }}
        paginator
      >
        <Column field="identifier" header="Identif." />
        <Column field="nomeFantasia" header="Fantasia" />
        <Column field="city" header="Cidade" style={tableCellCentered(150)} />
        <Column field="district" header="Bairro" style={tableCellCentered()} />
        <Column field="company_name" header="Empresa" />
        <Column
          field="weightTotal"
          header="Peso"
          body={item => <NumeroDecimal>{item.weightTotal}</NumeroDecimal>}
          style={tableCellCentered()}
        />
        <Column field="qte_sku" header="Qte. Sku" style={tableCellCentered()} />
        <Column
          field="status"
          header="Status"
          style={tableCellCentered(130)}
          body={entrega => <BadgeStatusEntrega status={entrega.status} />}
        />
        <Column
          style={tableCellCentered(130)}
          header="Possui Falta"
          body={entrega =>
            entrega.qte_faltas ? (
              <Badge color={colors.vinho}>sim</Badge>
            ) : (
              <Badge color={colors.verde}>não</Badge>
            )
          }
        />
        <Column
          style={tableCellCentered(130)}
          header="Possui Canhoto"
          body={entrega => {
            const requerCanhoto = STATUSES_REQUEREM_CANHOTO.includes(entrega.status_id)
            const temCanhoto = !!(entrega.path_canhoto)
            if (requerCanhoto) {
              return temCanhoto
                ? <Badge color={colors.azul}>sim</Badge>
                : <Badge color={colors.vermelho}>não</Badge>
            }
            return temCanhoto
              ? <Badge color={colors.azul}>sim</Badge>
              : <Badge color={colors.azul}>não</Badge>
          }}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={entrega => (
            <ThreeDots
              items={['Anexar/Visualizar canhoto']}
              onClick={() =>
                history.push('/main/entregas/anexar-canhoto', {
                  delivery_id: entrega.delivery_id,
                  returnTo: {
                    path: '/main/dashboard/painel-veiculos-em-rota',
                    fleet_id: veiculo.fleet_id,
                    pInicial,
                    pFinal,
                  },
                })
              }
            />
          )}
        />
      </DataTable>
    </CustomModal>
  )
}

export default ModalDetalhesVeiculo
